// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3SPE0","productName":"Table_productName__SlIsi"};